import pluralize from 'pluralize'

/** Accessible label for the AvatarList overflow badge, e.g. "+3 more items". */
export const getAvatarOverflowLabel = (count: number): string =>
  `+${count} more ${pluralize('item', count)}`
